import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { trackEvent } from "@/lib/analytics";
const CallToAction = () => {
  return <section className="relative py-20 md:py-24 overflow-hidden" style={{
    background: 'linear-gradient(135deg, hsl(192 100% 50% / 0.15) 0%, hsl(220 100% 60% / 0.15) 100%)'
  }}>
      {/* Decorative gradient borders */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-primary/30 to-transparent" />
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-primary/30 to-transparent" />
      
      {/* Content */}
      <div className="relative z-10 container mx-auto px-6 text-center">
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4 md:mb-6">
          Ready to lead with AI?
        </h2>
        
        <p className="text-lg md:text-xl text-muted-foreground mb-8 max-w-2xl mx-auto">Let's connect and design a plan for your AI journey        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Button variant="primary" size="lg" asChild>
            <Link
              to="/contact"
              onClick={() => trackEvent("cta_click", { cta_id: "footer_book_consultation", location: "call_to_action" })}
            >
              Book a Consultation
            </Link>
          </Button>
        </div>
      </div>
    </section>;
};
export default CallToAction;